import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    templateUrl: './404.page.html',
    styleUrls: ['./404.page.scss'],

})
export class Error404Page implements OnInit {
    attemptedUrl = '';

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.attemptedUrl = this.router.url;
    }
}
